import { publicUrl } from "../assets/publicUrl";

interface Props {
  /** Filename under public/ (e.g. logo_icon.png) */
  src?: string;
  /** SVG path data strings — rendered as a stroke icon when provided */
  paths?: string[];
  /** Emoji/letter fallback when no image or paths */
  mark?: string;
  accent?: string;
  /** Background tile behind a transparent image logo */
  bg?: string;
  size?: "sm" | "md";
  alt?: string;
}

const SIZE = { sm: "h-7 w-7", md: "h-8 w-8" } as const;
const ICON_SIZE = { sm: 16, md: 18 } as const;

const AppLogo: React.FC<Props> = ({
  src,
  paths,
  mark,
  accent = "#C9A260",
  bg,
  size = "md",
  alt = "",
}) => {
  const box = `${SIZE[size]} flex items-center justify-center flex-shrink-0`;

  if (src) {
    return (
      <img
        src={publicUrl(src)}
        alt={alt}
        className={`${box} object-contain${bg ? " p-0.5" : ""}`}
        style={bg ? { backgroundColor: bg } : undefined}
      />
    );
  }

  if (paths) {
    const px = ICON_SIZE[size];
    return (
      <div
        className={box}
        style={{ color: accent }}
        aria-hidden={!alt}
        title={alt || undefined}
      >
        <svg
          width={px}
          height={px}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          {paths.map((d, i) => (
            <path key={i} d={d} />
          ))}
        </svg>
      </div>
    );
  }

  return (
    <div
      className={`${box} text-[#111110] text-sm font-semibold`}
      style={{ backgroundColor: accent }}
      aria-hidden={!alt}
    >
      {mark}
    </div>
  );
};

export default AppLogo;
